import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';
import { deleteBankData } from '../requests/delete-bank-data.js';
import { refreshBankAndCards } from './bank-cache.js';

export const useDeleteBankDataMutation = (): UseMutationResult<void, Error, void> => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteBankData,
    onSuccess: () => refreshBankAndCards(queryClient),
  });
};
